export default __webpack_public_path__ + "fonts/iconfont.38ae1802fa9f0138cd5b81a14f486ed9.woff";